import { useMediaQuery } from '@vueuse/core';
import { computed } from 'vue';

const _isSamllScreen = useMediaQuery('(max-width: 1200px)');

const userAgent = typeof window !== 'undefined' ? window.navigator.userAgent.toLowerCase() : '';
const mobileDevices =
  /(android|webos|iphone|ipad|ipod|blackberry|windows phone|iemobile|opera mini|mobile|tablet|kindle)/i;
const isMobileDevice = mobileDevices.test(userAgent);

export const isSamllScreen = computed(() => _isSamllScreen.value);

export const isMobile = computed(() => isSamllScreen.value && isMobileDevice);
